import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, renderSlot } from 'vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Text",
  props: {
    lead: { type: Boolean, default: false },
    size: { default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const size = computed(() => {
      let size2 = "";
      if (props.lead) {
        size2 = "text--lead";
      } else if (props.size) {
        size2 = `text--${props.size}`;
      }
      return size2;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["text", { [size.value]: size.value }, "rte-text"])
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});

export { _sfc_main as default };
